import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="text-xl font-bold">
                <span className="text-blue-400">Nexus</span>
                <span className="text-white">ERP</span>
              </span>
            </Link>
            <p className="text-slate-400 text-sm leading-relaxed">
              The nexus between your Odoo ERP and modern interfaces. Connect marketplaces, build dashboards, empower your team.
            </p>
          </div>

          {/* Connectors */}
          <div>
            <h4 className="text-white font-semibold mb-4">Connectors</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/connectors" className="text-slate-400 hover:text-white transition-colors text-sm">
                  GunBroker
                </Link>
              </li>
              <li>
                <Link to="/connectors" className="text-slate-400 hover:text-white transition-colors text-sm">
                  eBay
                </Link>
              </li>
              <li>
                <Link to="/connectors" className="text-slate-400 hover:text-white transition-colors text-sm">
                  ShipStation
                </Link>
              </li>
              <li>
                <Link to="/connectors" className="text-slate-400 hover:text-white transition-colors text-sm">
                  View All
                </Link>
              </li>
            </ul>
          </div>

          {/* Platform */}
          <div>
            <h4 className="text-white font-semibold mb-4">Platform</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/features" className="text-slate-400 hover:text-white transition-colors text-sm">
                  Features
                </Link>
              </li>
              <li>
                <Link to="/features" className="text-slate-400 hover:text-white transition-colors text-sm">
                  Reporting
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="text-slate-400 hover:text-white transition-colors text-sm">
                  Pricing
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-white font-semibold mb-4">Company</h4>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-slate-400 hover:text-white transition-colors text-sm">
                  About
                </a>
              </li>
              <li>
                <a href="#" className="text-slate-400 hover:text-white transition-colors text-sm">
                  Contact
                </a>
              </li>
              <li>
                <a href="#" className="text-slate-400 hover:text-white transition-colors text-sm">
                  Privacy
                </a>
              </li>
              <li>
                <a href="#" className="text-slate-400 hover:text-white transition-colors text-sm">
                  Terms
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-12 pt-8 border-t border-slate-800">
          <p className="text-slate-500 text-sm text-center">
            &copy; {currentYear} NexusERP. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
